import React from "react"
import CSVReader from "react-csv-reader"
import {getPost} from "../utils/commHelper";

const ImportCsv = ({table, apiTarget}) => {

    return (
        <div className="app">
            <CSVReader onFileLoaded={async (data, fileInfo, originalFile) => {
                // console.log(data, fileInfo, originalFile)

                const columns = data[0]
                columns[columns.findIndex(e => e === "ID")] = "_id"
                columns[columns.findIndex(e => e === "Created Date")] = "_createdDate"
                columns[columns.findIndex(e => e === "Updated Date")] = "_updatedDate"

                const items = []
                data.forEach((row, rowIndex) => {
                    if (rowIndex > 0 && row.length > 1) {
                        row.forEach((item, index) => {
                            if (!items[rowIndex]) {
                                items[rowIndex] = {}
                            }
                            if (columns[index] !== "Owner") {
                                items[rowIndex][columns[index]] = item
                            }
                        })

                    }

                })


                items.forEach((item, index) => {
                    Object.keys(item).forEach(key => {
                        try {
                            if (Array.isArray(JSON.parse(item[key]))) {
                                items[index][key] = JSON.parse(item[key]).map(e => ({"_id": e}))
                            }
                        } catch (e) {

                        }

                    })
                })


                const perChunk = 20 // items per chunk


                const result = items.reduce((resultArray, item, index) => {
                    const chunkIndex = Math.floor(index / perChunk)

                    if (!resultArray[chunkIndex]) {
                        resultArray[chunkIndex] = [] // start a new chunk
                    }

                    resultArray[chunkIndex].push(item)

                    return resultArray
                }, [])

                console.log(result)

                for (const i of result) {
                    await getPost("/insertBulkBalance", {values: i, table}, apiTarget).then(res => {
                        if (res.data.error) {
                            console.error({error: res.data.error, i})
                        }
                    }).catch(e => {
                        console.error({error: e.message, i})
                    })
                }

                // axios.post("http://localhost:8080/insertBulkBalance", {values: items, table})
                // console.log(items)
            }}/>
        </div>
    )
}
export default ImportCsv